/**
 * Created by alex on 2017/7/12.
 */
export default {
  en: {
    lang: {
      category: 'Category',
      name: 'Name',
      version: 'Version',
      updateDate: 'Update Date',
      download: 'Download',
      firmware: 'Firmware(Only for test)',
      software: 'Software(Only for test)',
      description: 'Description',
      releaseNote: 'Release Note',
      history: 'All Version',
      title: 'UFACTORY beta Download Center',
    },
  },
  cn: {
    lang: {
      category: '类型',
      name: '名称',
      version: '版本号',
      updateDate: '更新日期',
      download: '下载',
      firmware: '固件(仅供测试)',
      software: '软件(仅供测试)',
      description: '描述',
      releaseNote: '更新日志',
      history: '历史版本',
      title: 'UFACTORY 测试版 下载中心',
    },
  },
};



// WEBPACK FOOTER //
// ./src/lang.js